import React, { useState, useEffect } from 'react';
import DOMPurify from 'dompurify';

const TraditionalMCScrambledPreview = ({ assessmentItem }) => {
    const sanitizeContent = (content) => DOMPurify.sanitize(content);

    // Shuffle responses function
    const shuffleArray = (array) => array.sort(() => 0.5 - Math.random());

    const [shuffledResponses, setShuffledResponses] = useState([]);

    useEffect(() => {
        // Sanitize and shuffle responses on initial mount
        const responses = [
            sanitizeContent(assessmentItem.correct),
            sanitizeContent(assessmentItem.distractor1),
            sanitizeContent(assessmentItem.distractor2),
            sanitizeContent(assessmentItem.distractor3),
        ];
        setShuffledResponses(shuffleArray(responses));
    }, [assessmentItem]);

    const renderHtml = (htmlString) => {
        const sanitizedHtml = DOMPurify.sanitize(htmlString);
        return { __html: sanitizedHtml };
    };

    return (
        <div className={'w-full bg-dutch_white-100 p-1 rounded'}>
            <div className={'flex flex-col p-1 bg-dutch_white-200 my-2'} tabIndex={0}>
                {Object.keys(assessmentItem).includes('imageURL') && (
                    <img
                        className={`max-h-[100px] rounded mx-auto`}
                        src={assessmentItem.imageURL}
                        alt="Assessment Prompt Image"
                    />
                )}
                <div className={'flex flex-col gap-2 bg-paynes_gray-300 p-1 rounded w-full'}>
                    <div className={'bg-platinum rounded p-1 border-2 border-columbia_blue'}>
                        <div dangerouslySetInnerHTML={renderHtml(sanitizeContent(assessmentItem.prompt))} />
                    </div>
                    {shuffledResponses.map((item, index) => (
                        (item === assessmentItem.correct) ?
                            <div key={index}
                                 className={'group flex bg-dutch_white-200 hover:bg-columbia_blue-800 hover:text-dutch_white-100 text-sm rounded p-1 border-2 border-opacity-50 border-dutch_white-700 hover:border-dutch_white-100 text-left'}>
                                <svg// Position the label just above the bottom of the bar
                                    width={20}
                                    height={20}
                                    viewBox="0 0 24 24"
                                    fill="none"
                                    stroke="black"
                                    strokeWidth="2"
                                    className={'group-hover:opacity-100 opacity-0'}
                                >{/* Added fill to rectangle */}
                                    <path d="M4 12 L8 16 L16 8" stroke="#f6f0e0" strokeWidth="1.5" fill="none"/>
                                    {/* Centered the checkmark */}
                                </svg>
                                <div dangerouslySetInnerHTML={renderHtml(item)}/>
                            </div>
                            :
                            <div key={index}
                                 className={'bg-dutch_white-200 text-sm flex rounded p-1 border-2 border-opacity-50 border-dutch_white-700'}>
                                <div className={'pl-[20px] text-left'} dangerouslySetInnerHTML={renderHtml(item)}/>
                            </div>
                    ))}
                </div>
            </div>
        </div>
    );
};

export default TraditionalMCScrambledPreview;
